import React, { useState } from "react";
import { chamarAdmin, mensagemDeErro } from "../../lib/adminApi";

// "Trocar minha senha": pede a senha atual. As outras sessões da pessoa caem; esta continua.
const TrocarSenha: React.FC<{ aoFechar: () => void }> = ({ aoFechar }) => {
  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [repetida, setRepetida] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [pronto, setPronto] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const enviar = async () => {
    setErro(null);
    if (nova.length < 12) return setErro(mensagemDeErro("senha_curta"));
    if (nova !== repetida) return setErro("As senhas novas não conferem.");
    setEnviando(true);
    try {
      const r = await chamarAdmin("/api/admin", { acao: "trocar-senha", atual, nova });
      if (!r.ok) return setErro(mensagemDeErro(r.json?.erro));
      setPronto(true);
      setAtual("");
      setNova("");
      setRepetida("");
    } catch {
      setErro("Sem conexão com o servidor.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <section className="metricas-bloco trocar-senha">
      <h2>Trocar minha senha</h2>
      {pronto ? (
        <>
          <p className="metricas-legenda">Senha trocada. Se você estava logado em outro computador, aquela sessão foi encerrada.</p>
          <button type="button" className="metricas-sair" onClick={aoFechar}>
            Fechar
          </button>
        </>
      ) : (
        <form
          className="usuarios-form"
          onSubmit={(e) => {
            e.preventDefault();
            enviar();
          }}
        >
          <input type="password" autoComplete="current-password" placeholder="Senha atual" value={atual} onChange={(e) => setAtual(e.target.value)} />
          <input type="password" autoComplete="new-password" placeholder="Nova senha (mín. 12)" value={nova} onChange={(e) => setNova(e.target.value)} />
          <input type="password" autoComplete="new-password" placeholder="Repita a nova senha" value={repetida} onChange={(e) => setRepetida(e.target.value)} />
          <button type="submit" disabled={enviando || !atual || !nova || !repetida}>
            {enviando ? "Salvando…" : "Salvar"}
          </button>
          <button type="button" className="usuarios-fechar" onClick={aoFechar}>
            Cancelar
          </button>
        </form>
      )}
      {erro && <p className="metricas-erro">{erro}</p>}
    </section>
  );
};

export default TrocarSenha;
